import React from 'react'
import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'

export default function Forbidden() {
  return (
    <>
      <SEOHead title="403 - Adgang nægtet - Agstner Byg ApS" />
      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-zinc-950 px-4">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="w-20 h-20 bg-orange-500 text-zinc-950 font-display flex items-center justify-center mx-auto text-3xl font-black">
            403
          </div>
          <h1 className="text-3xl sm:text-4xl font-display font-bold text-white uppercase tracking-tight">
            Adgang nægtet
          </h1>
          <p className="text-zinc-300 text-xs sm:text-sm leading-relaxed">
            Du har ikke adgang til denne ressource. Benyt navigationen herunder for at vende tilbage til vores offentlige sider.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4 text-xs font-display font-bold uppercase tracking-wider">
            <Link to="/" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Forside
            </Link>
            <Link to="/tomrerarbejde" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Tømrerarbejde
            </Link>
            <Link to="/tag" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Tag
            </Link>
            <Link to="/renovering" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Renovering
            </Link>
            <Link to="/projekter" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Projekter
            </Link>
            <Link to="/kontakt" className="p-3 bg-orange-500 text-zinc-950 font-bold border border-orange-500 hover:bg-orange-600 transition-all">
              Få et tilbud
            </Link>
          </div>

          <div className="pt-6 border-t border-zinc-800 text-xs text-zinc-400">
            Kontakt Agstner Byg ApS direkte på{' '}
            <a href="tel:+4552502543" className="text-orange-500 font-bold whitespace-nowrap hover:underline">
              52 50 25 43
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
